import React from 'react';
import classnames from 'classnames';

export interface CardWrapperProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  component?: React.ElementType;
  element?: keyof JSX.IntrinsicElements;
}

const CardWrapper: React.FunctionComponent<CardWrapperProps> = ({
  element = 'div',
  component,
  className,
  ...props
}) => {
  const CardElement = component || element;

  return <CardElement className={classnames('card', className)} {...props} />;
};

export default CardWrapper;
